import { Check } from 'lucide-react';

const STEPS = ['Personal', 'Address', 'Emergency', 'Employment', 'Banking', 'Documents', 'Policies'];

interface Props { currentStep: number; completedSteps: number[]; onStepClick?: (step: number) => void; }

export default function WizardProgress({ currentStep, completedSteps, onStepClick }: Props) {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center gap-1 mb-2 overflow-x-auto">
        {STEPS.map((label, i) => {
          const step = i + 1;
          const done = completedSteps.includes(step);
          const active = step === currentStep;
          const accessible = done || step <= Math.max(...completedSteps, 1) + 1;
          return (
            <div key={step} className="flex items-center shrink-0">
              <button
                onClick={() => accessible && onStepClick?.(step)}
                disabled={!accessible}
                className={`flex flex-col items-center gap-1 px-2 py-1 rounded transition-colors min-w-[52px] ${active ? 'text-primary' : done ? 'text-green-500 cursor-pointer' : accessible ? 'text-muted-foreground hover:text-foreground cursor-pointer' : 'text-muted-foreground/40 cursor-not-allowed'}`}
              >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 ${active ? 'border-primary bg-primary text-primary-foreground' : done ? 'border-green-500 bg-green-500/10 text-green-500' : 'border-border'}`}>
                  {done ? <Check className="w-3.5 h-3.5" /> : step}
                </div>
                <span className="text-[10px] font-medium hidden sm:block">{label}</span>
              </button>
              {i < STEPS.length - 1 && (
                <div className={`h-0.5 w-4 mx-0.5 ${done ? 'bg-green-500' : 'bg-border'}`} />
              )}
            </div>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1]}</p>
    </div>
  );
}
